import LinearProgress from "@mui/material/LinearProgress";

const PageLoader = () => {
  return (
    <div
      style={{
        width: "100%",
        position: "fixed",
        top: 0,
        left: 0,
      }}
    >
      <div style={{ width: "100%" }}>
        <LinearProgress />
      </div>
    </div>
  );
};
export default PageLoader;
